import { useContext } from 'react';

import { InsuranceTypeContext } from '../context/InsuranceTypeContext';

export const useInsuranceType = () => {
  const context = useContext(InsuranceTypeContext);
  if (context === undefined) {
    throw new Error(
      'useInsuranceType must be used within an InsuranceTypeProvider'
    );
  }
  return context;
};
